import { DocumentDto } from '@fleet-beat/core';

export interface TruckDocumentDto extends DocumentDto {
  id?: string;
  tenantId?: string;
  truckID?: string;
}
